import { AvField, AvForm } from "availity-reactstrap-validation";
import Footer from "components/Website/Layouts/Footer";
import Navbar from "components/Website/Layouts/Navbar";
import { Link } from "react-router-dom";
import {
	Breadcrumb,
	BreadcrumbItem,
	CardText,
	Col,
	Container,
	Row,
} from "reactstrap";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Select from "react-select";
import ContactUsService from "services/Website/ContactUsService";
import { SuccessOk } from "configs/statusCode";
import SuccessModal from "components/SucessModal";
import { useSelector } from "react-redux";
import imgLocation from "assets/images/markerContact.png";
import imgEmail from "assets/images/emailContact.png";
import imgCall from "assets/images/phoneContact.png";
import "./style.scss";

function ContactUs(props) {
	const [successModal, setSuccessModal] = useState(false);
	const [loading, setLoading] = useState(false);
	const { t } = useTranslation();
	const Auth = useSelector((state) => state.Auth);
	const contactUsService = new ContactUsService();
	const communicationTypes = [
		{ label: t("Email"), value: "Email" },
		{ label: t("Whatsapp"), value: "Whatsapp" },
		{ label: t("Zoom Meeting"), value: "Zoom Meeting" },
		{ label: t("Call"), value: "Call" },
	];
	const [formState, setFormState] = useState({
		name: "",
		email: "",
		phone: "",
		description: "",
		communication_type: {},
	});

	useEffect(() => {
		setFormState((prev) => ({
			...prev,
			communication_type: { label: t("Email"), value: "Email" },
		}));
	}, [Auth]);

	const handleFieldChange = (e) => {
		setFormState({ ...formState, [e.target.name]: e.target.value });
	};

	const sumbmitFormHandler = (e, values) => {
		if (!values.communication_type?.value) {
			return toast.error("Please Select Communication Type");
		}

		setLoading(true);
		let data = {
			name: formState.name,
			phone: formState.phone,
			description: formState.description,
			email: formState.email,
			communication_type: formState.communication_type.value,
		};

		contactUsService.contactUs(data).then((res) => {
			if (res.status === SuccessOk) {
				setLoading(false);
				setSuccessModal(true);
			}
		});
	};

	return (
		<div className="websitPages">
			<Navbar />
			<div className="firstSection">
				<div className="overlaySection"></div>
			</div>
			<Container className="pt-8rem contact-page">
				<div className="hearForm w-100 filterHome rounded-80">
					<Row className="d-flex justify-content-center">
						<Col md={11}>
							<div className="text-center pb-lg-4">
								<p
									dangerouslySetInnerHTML={{
										__html: t("Contact Information"),
									}}
									tag="h3"
									className="text-primary contact-information"></p>
								<CardText tag="p" className="text-primary cotacts pt-4">
									<img src={imgLocation} width="25" className="mx-1" alt="" />{" "}
									{t(
										"Floor 3, El Aykona building, 16 Mohamed Sakep EL zamalek, Cairo"
									)}
								</CardText>
								<div
									className="d-lg-flex justify-content-center mt-4 mb-lg-5 mb-2"
									style={{ gap: "7rem" }}>
									<CardText tag="p" className="text-primary cotacts pt-2">
										{/* <img src={imgEmail} width="25" className="mx-1" alt="" /> */}
										<i class="fa fa-envelope" />
										<a href="mailto:info@sakneen.com" className="text-primary">
											{t("Info@sakneen.com")}
										</a>
									</CardText>
									<CardText tag="p" className="text-primary cotacts pt-2">
										{/* <img src={imgCall} width="25" className="mx-1" alt="" /> */}
										<i class="fa fa-phone" />
										<a href="tel:1992" className="text-primary">
											1992
										</a>
									</CardText>
								</div>
								{/* <h3 className="text-black pt-5 fw-bold">{t("We would love to hear from you!")}</h3>
                                <p>{t("Our customer service team will reply to youas quickly as possible.")}</p> */}
							</div>
							<div className="">
								<div className="custom-title">
									<p className="main-title">{t("WE WOULD LOVE")}</p>
									<div className="d-lg-flex">
										<p className="description-title">
											OUR CUSTOMER SERVICE team will reply to you as quickly as
											possible.
										</p>
										<p className="second-title">TO</p>
										<p className="italic-title">{t("hear from you!")}</p>
									</div>
								</div>
								<AvForm
									className="px-4 pb-md-5 pb-4"
									onValidSubmit={(e, v) => sumbmitFormHandler(e, v)}>
									<Row className="pt-3 justify-content-between">
										<Col lg={5} md={6} className="pb-4 custom-input">
											<AvField
												name="name"
												className="form-control rounded-3 height-50"
												label={t("Name")}
												required
												type="text"
											/>
										</Col>
										<Col lg={5} md={6} className="pb-4 custom-input">
											<AvField
												name="email"
												className="form-control rounded-3 height-50"
												label={t("Email")}
												required
												type="email"
											/>
										</Col>
										<Col lg={5} md={6} className="pb-4 custom-input">
											<AvField
												className="font-size-14 height-50"
												label={t("Phone")}
												name="phone"
												bsSize="lg"
												required
												// maxLength={11}
												// minLength={11}
												type="number"
											/>
										</Col>
										<Col lg={5} md={6} className="pb-4">
											<Select
												name="communication_type"
												placeholder={t("Type Of Communication")}
												className="selectHeight"
												style={{ height: "50px" }}
												options={communicationTypes}
											/>
										</Col>
									</Row>
									<AvField
										name="description"
										label={t("Your Inquiry")}
										rows="4"
										required
										placeholder={t("Write Here")}
										type="textarea"
										className="mb-3 rounded-4 pt-3"
									/>
									<div className="text-center">
										<button
											type="submit"
											className="btn btn btnOrange my-4 height-50 w-100 font-size-16 text-center"
											size={"lg"}>
											{t("Send Message")}
										</button>
									</div>
								</AvForm>
							</div>
							{/* <AvForm onValidSubmit={(e, v) => sumbmitFormHandler(e, v)}>
                                <Row className="pt-3">
                                    <Col md={6} className="pb-3">
                                        <AvField
                                            name="name"
                                            className="form-control rounded-3 btnHeight rounded-pill px-3"
                                            label={t("Name")}
                                            required
                                            placeholder={t("Enter your full name")}
                                            value={formState.name}
                                            type="text"
                                            onChange={(e) => handleFieldChange(e)}
                                        />
                                    </Col>
                                    <Col md={6} className="pb-3">
                                        <AvField
                                            name="email"
                                            className="form-control rounded-3 btnHeight rounded-pill px-3"
                                            label={t("Email")}
                                            required
                                            placeholder={t("Enter your email address")}
                                            value={formState.email}
                                            type="email"
                                            onChange={(e) => handleFieldChange(e)}
                                        />
                                    </Col>
                                    <Col md={6} className="pb-3">
                                        <AvField
                                            className="mb-3 font-size-14 rounded-pill px-3"
                                            label= {t("Phone Number")}
                                            name="phone"
                                            bsSize="lg"
                                            required
                                            maxLength={11}
                                            minLength={11}
                                            type="number"
                                            placeholder={t("Phone Number")}
                                            value={formState.phone}
                                            onChange={(e) => handleFieldChange(e)}
                                        />
                                    </Col>
                                    <Col md={6}>
                                            <label>{t("Kindly Select the Type of Communication you want")}:</label>
                                            <Select
                                                name="communication_type"
                                                placeholder='Select'
                                                options={communicationTypes}
                                                className='mb-3 rounded-pill'
                                                onChange={(e) => setFormState({...formState, communication_type: e})}
                                                value={formState.communication_type}
                                            />
                                    </Col>
                                </Row>
                                <AvField
                                    name="description"
                                    className="rounded-3"
                                    rows="4"
                                    label={t("Description")}
                                    required
                                    placeholder={t("Enter your Inquiry")}
                                    value={formState.description}
                                    type="textarea"
                                    onChange={(e) => handleFieldChange(e)}
                                />
                                <button type="submit" disabled={loading}
                                className="btn btnOrange btnHeight my-4 w-100 font-size-16 text-center" size={"lg"}>
                                    {t("Send")}
                                </button>
                            </AvForm> */}
						</Col>
					</Row>
				</div>
			</Container>
			<Footer />

			<SuccessModal
				modal={successModal}
				message="Email Sent Successfully"
				onClick={() => {
					props.history.goBack();
					window.scrollTo({
						top: 0,
						behavior: "smooth",
					});
				}}
				title=""
			/>
		</div>
	);
}

export default ContactUs;
